export default __webpack_public_path__ + "static/media/miguel-lopes-4.9b788a34.jpg";